// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/.pnpm/css-loader@6.3.0_webpack@5.99.8/node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/.pnpm/css-loader@6.3.0_webpack@5.99.8/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".ConfirmationModal-cls1__cdfd186b12ccfd0efe1d{/*!*/}.ConfirmationModal-cls2__a12ee8cd0f9632ac24d2{font-size:14px;height:32px}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"cls1": "ConfirmationModal-cls1__cdfd186b12ccfd0efe1d",
	"cls2": "ConfirmationModal-cls2__a12ee8cd0f9632ac24d2 ConfirmationModal-cls1__cdfd186b12ccfd0efe1d"
};
export default ___CSS_LOADER_EXPORT___;
